export enum UserType {
  Patient = 'patient',
  Admin = 'admin',
  Practice = 'practice',
  HomeHealth = 'homeHealth',
}
